import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

export const getProductDropdownList = async (data) => {
  return decryptData(
    await axios.get(
      `/getProductDropdownList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getItemSalesCustomerListById = async (data) => {
  return decryptData(
    await axios.get(
      `/getItemSalesCustomerListById?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getItemSalesCustomerList = async (data) => {
  return decryptData(
    await axios.get(
      `/getItemSalesCustomerList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addItemSalesCustomer = async (data) => {
    return decryptData(
      await axios.post(`/addItemSalesCustomer`, {
        reqData: encryptData({
          ...data,
          access_token: isLoggedIn(),
        }),
      })
    );
  };

export const updateItemSalesCustomer = async (data) => {
    return decryptData(
      await axios.post(`/updateItemSalesCustomer`, {
        reqData: encryptData({
          ...data,
          access_token: isLoggedIn(),
        }),
      })
    );
  };

  
